/**
 * Aggregated FORA programme data per market.
 * Used by the live markets map, outlet growth chart and ROI calculator.
 *
 * NOTE: numbers are illustrative for showcase. Real values will arrive via
 * the AWS QuickSight integration.
 */

// status: live | piloting | onboarding | planned
export const markets = [
  { code: "HR", name: "Croatia", status: "live", outlets: 3488, products: ["QR Menu", "Videri", "POS"], owner: "Igor Guberovic", lat: 45.1, lng: 15.2 },
  { code: "PL", name: "Poland", status: "live", outlets: 786, products: ["QR Menu", "Videri"], owner: "Katarzyna Stanczak", lat: 52.0, lng: 19.5 },
  { code: "SI", name: "Slovenia", status: "live", outlets: 766, products: ["QR Menu"], owner: "—", lat: 46.1, lng: 14.8 },
  { code: "BA", name: "Bosnia & Herzegovina", status: "live", outlets: 890, products: ["QR Menu", "Videri"], owner: "—", lat: 43.9, lng: 17.7 },
  { code: "MK", name: "North Macedonia", status: "live", outlets: 683, products: ["QR Menu"], owner: "Bojan Krstevski", lat: 41.6, lng: 21.7 },
  { code: "RS", name: "Serbia", status: "live", outlets: 29, products: ["QR Menu"], owner: "—", lat: 44.0, lng: 20.9 },
  { code: "RO", name: "Romania", status: "live", outlets: 29, products: ["QR Menu"], owner: "—", lat: 45.9, lng: 24.9 },
  { code: "AT", name: "Austria", status: "onboarding", outlets: 0, products: [], owner: "Orcun Sacan", lat: 47.5, lng: 14.5 },
  { code: "HU", name: "Hungary", status: "planned", outlets: 0, products: [], owner: "—", lat: 47.2, lng: 19.5 },
  { code: "CZ", name: "Czech Republic", status: "planned", outlets: 0, products: [], owner: "—", lat: 49.8, lng: 15.5 },
  { code: "SK", name: "Slovakia", status: "planned", outlets: 0, products: [], owner: "—", lat: 48.7, lng: 19.7 },
  { code: "BG", name: "Bulgaria", status: "planned", outlets: 0, products: [], owner: "—", lat: 42.7, lng: 25.5 },
  { code: "GR", name: "Greece", status: "planned", outlets: 0, products: [], owner: "—", lat: 39.1, lng: 22.0 },
  { code: "IE", name: "Ireland", status: "planned", outlets: 0, products: [], owner: "—", lat: 53.4, lng: -8.0 },
  { code: "CY", name: "Cyprus", status: "planned", outlets: 0, products: [], owner: "—", lat: 35.0, lng: 33.0 },
];

export const statusMeta = {
  live: { label: "Live", color: "#dd260e", textColor: "#fff" },
  piloting: { label: "Piloting", color: "#f59e0b", textColor: "#000" },
  onboarding: { label: "Onboarding", color: "#000000", textColor: "#fff" },
  planned: { label: "Planned", color: "#e8e8e8", textColor: "#555555" },
};

/**
 * Synthetic monthly outlet growth (last 12 months, by status group).
 * Approximates the cumulative ramp from ~3,500 to ~6,671 outlets.
 */
export const outletGrowth = [
  { month: "Mar 25", HR: 2540, PL: 220, BA: 480, SI: 410, MK: 320, RS: 0, RO: 0 },
  { month: "Apr 25", HR: 2680, PL: 280, BA: 530, SI: 470, MK: 380, RS: 0, RO: 0 },
  { month: "May 25", HR: 2820, PL: 340, BA: 580, SI: 520, MK: 440, RS: 0, RO: 0 },
  { month: "Jun 25", HR: 2980, PL: 410, BA: 630, SI: 570, MK: 490, RS: 5, RO: 0 },
  { month: "Jul 25", HR: 3120, PL: 470, BA: 680, SI: 620, MK: 540, RS: 12, RO: 0 },
  { month: "Aug 25", HR: 3220, PL: 530, BA: 720, SI: 660, MK: 580, RS: 18, RO: 5 },
  { month: "Sep 25", HR: 3300, PL: 600, BA: 760, SI: 690, MK: 610, RS: 22, RO: 10 },
  { month: "Oct 25", HR: 3360, PL: 660, BA: 800, SI: 720, MK: 640, RS: 25, RO: 18 },
  { month: "Nov 25", HR: 3410, PL: 710, BA: 830, SI: 740, MK: 660, RS: 27, RO: 24 },
  { month: "Dec 25", HR: 3450, PL: 750, BA: 860, SI: 755, MK: 675, RS: 28, RO: 27 },
  { month: "Jan 26", HR: 3475, PL: 765, BA: 880, SI: 762, MK: 680, RS: 29, RO: 28 },
  { month: "Feb 26", HR: 3488, PL: 786, BA: 890, SI: 766, MK: 683, RS: 29, RO: 29 },
];

export const totalOutlets = () => markets.reduce((acc, m) => acc + m.outlets, 0);
export const liveMarketsCount = () => markets.filter((m) => m.status === "live").length;
